import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  Jaarrapportage,
  IncomeStatementClassification,
  CashFlowStatementMethod, PublicationWNTfinancialStatement, FinancialStatementValue, Email, BasisOfPreparationValue
} from '@snelstart-ventures/fiscaal/domain-logic';
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { combineLatest, filter, Subscription } from 'rxjs';
import {Event, NavigationEnd, Router} from "@angular/router";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-info-rapportage',
  templateUrl: './info-rapportage.component.html',
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ],
  styleUrls: ['./info-rapportage.component.scss']
})
export class InfoRapportageComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private combinedSubscription:Subscription |undefined
  private routerSubscription: Subscription | undefined;
  private isSaving = false;
  public jrEntity = {} as JaarrapportageEntity;
  public informatieRapportageFg = {} as FormGroup;
  public isRechtspersoon = false;
  public heeftAandelen = false;
  public heeftAfwijkendRapportageJaar = false;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public optionsBasisOfPreparation: SelectFormControlItem<string>[] = [
    {value: "COMMERCIEEL", label: "Commercieel"},
    {value: "FISCAAL", label: "Fiscaal"},
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private router: Router,
    private fb: FormBuilder) {
    this.informatieRapportageFg = this.fb.group({
      titleOfTheDocument: this.fb.group({
        value: null as unknown as string,
      }),
      financialReportingPeriodCurrentStartDate: this.fb.group({
        value: null as unknown as Date,
      }),
      financialReportingPeriodCurrentEndDate: this.fb.group({
        value: null as unknown as Date,
      }),
      financialReportingPeriodPreviousStartDate: this.fb.group({
        value: null as unknown as Date,
      }),
      financialReportingPeriodPreviousEndDate: this.fb.group({
        value: null as unknown as Date,
      }),
      financialReportingPeriodDifferentThanAnnualStatus: this.fb.group({
        value: null as unknown as boolean,
      }),
      financialReportingPeriodDifferentThanAnnualReason: this.fb.group({
        value: null as unknown as string,
      }),
      financialReportingPeriodDifferentThanAnnualImpactComparatives: this.fb.group({
        value: null as unknown as string,
      }),
      documentRelatesToIndividualEntityOrGroup: this.fb.group({
        value: FinancialStatementValue.ENKELVOUDIG,
      }),
      documentPresentationCurrency: this.fb.group({
        value: "EUR",
      }),
      basisOfPreparation: this.fb.group({
        value: null as unknown as string,
      }),
      incomeStatementClassificationType: this.fb.group({
        value: null as unknown as IncomeStatementClassification,
      }),
      cashFlowStatementMethodType: this.fb.group({
        value: null as unknown as CashFlowStatementMethod,
      }),
      financialStatementsDateOfPreparation: this.fb.group({
        value: null as unknown as Date,
      }),
      documentAdoptionStatus: this.fb.group({
        value: true,
      }),
      documentAdoptionDate: this.fb.group({
        value: null as unknown as Date,
      }),
      documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuracies: this.fb.group({
        value: false,
      }),
      documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuraciesExplanation: this.fb.group({
        value: null as unknown as string,
      }),
      documentResubmissionDueToUnsurmountableInaccuracies: this.fb.group({
        value: false,
      }),
      documentResubmissionDueToUnsurmountableInaccuraciesExplanation: this.fb.group({
        value: null as unknown as string,
      }),
      emailAddressFull: this.fb.group({
        value: null as unknown as string,
      }),
      publicationWNTInTheConsolidatedStatutoryAccounts: this.fb.group({
        value: null as unknown as PublicationWNTfinancialStatement,
      }),
      referenceToTheSeniorOfficialsAndCorrespondingStatutoryEntities: this.fb.group({
        value: null as unknown as string,
      }),
      applicableMaximumRemunerationInstitution: this.fb.group({
        value: null as unknown as string,
      }),
    })
  }

  ngOnInit(): void {
    this.combinedSubscription = combineLatest([
      this.algDataService.intermediary,
      this.jrDataService.jaarrapportageEntity
    ]).subscribe(([intermediary, jaarrapportageEntity]) => {
      this.jrEntity = jaarrapportageEntity;

      const informatieRapportage = jaarrapportageEntity.rapportage?.informatieRapportage
      if (informatieRapportage) {
        if (intermediary) {
          if ((informatieRapportage.emailAddressFull?.value == undefined || informatieRapportage.emailAddressFull?.value == "")
            && intermediary.officeEmail) {
            informatieRapportage.emailAddressFull = {} as Email;
            informatieRapportage.emailAddressFull.value = intermediary.officeEmail
          }
        }
        this.informatieRapportageFg.patchValue(informatieRapportage, { emitEvent: false })
        this.bepaalAfwijkendRapportageJaar();
      }
    });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
    this.jrDataService.heeftAandelen.subscribe((value) => {
      this.heeftAandelen = value;
    })
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleUrlChange(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.combinedSubscription) {
      this.combinedSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
  }

  public get isDocumentAdoptionStatus(): boolean {
    return (
      this.informatieRapportageFg?.get('documentAdoptionStatus')?.get('value')?.value === true
    );
  }

  bepaalAfwijkendRapportageJaar() {
    const inputDateStartCtrl = this.informatieRapportageFg.get('financialReportingPeriodCurrentStartDate')?.value;
    const inputDateEndCtrl = this.informatieRapportageFg.get('financialReportingPeriodCurrentEndDate')?.value;

    if (!inputDateStartCtrl || !inputDateEndCtrl) {
      this.heeftAfwijkendRapportageJaar = true;
      return;
    }

    const inputDateStart = new Date(inputDateStartCtrl.value);
    const inputDateEnd = new Date(inputDateEndCtrl.value);

    //maak een datum die precies 1 jaar - 1 dag na de startdatum ligt
    const expectedEndDate = new Date(inputDateStart);
    expectedEndDate.setFullYear(expectedEndDate.getFullYear() + 1);
    expectedEndDate.setDate(expectedEndDate.getDate() - 1);

    //vergelijk datums door alleen naar de dag, maand, jaar te kijken
    const sameDay = inputDateEnd.getDate() === expectedEndDate.getDate();
    const sameMonth = inputDateEnd.getMonth() === expectedEndDate.getMonth();
    const sameYear = inputDateEnd.getFullYear() === expectedEndDate.getFullYear();

    this.heeftAfwijkendRapportageJaar = !(sameDay && sameMonth && sameYear);

    // this.informatieRapportageFg.patchValue({ financialReportingPeriodDifferentThanAnnualStatus: this.heeftAfwijkendRapportageJaar }, {emitEvent: false})
  }

  saveForm(): void {
    this.bepaalAfwijkendRapportageJaar()

    if (!this.isRechtspersoon) {
      this.informatieRapportageFg.patchValue({
        documentAdoptionStatus: {
          value: false
        }
      });
    }

    if (this.isDocumentAdoptionStatus !== true) {
      this.informatieRapportageFg.patchValue({
        documentAdoptionDate: {
          value: null
        }
      });
    }

    this.informatieRapportageFg.updateValueAndValidity({ emitEvent: false });

    setTimeout(()=>{
      this.jrEntity = {
        ...this.jrEntity,
        rapportage: {
          ...this.jrEntity.rapportage,
          informatieRapportage: {
            ...this.jrEntity.rapportage?.informatieRapportage,
            titleOfTheDocument: this.informatieRapportageFg.value.titleOfTheDocument,
            financialReportingPeriodCurrentStartDate: this.informatieRapportageFg.value.financialReportingPeriodCurrentStartDate,
            financialReportingPeriodCurrentEndDate: this.informatieRapportageFg.value.financialReportingPeriodCurrentEndDate,
            financialReportingPeriodPreviousStartDate: this.informatieRapportageFg.value.financialReportingPeriodPreviousStartDate,
            financialReportingPeriodPreviousEndDate: this.informatieRapportageFg.value.financialReportingPeriodPreviousEndDate,
            financialReportingPeriodDifferentThanAnnualStatus: this.informatieRapportageFg.value.financialReportingPeriodDifferentThanAnnualStatus,
            financialReportingPeriodDifferentThanAnnualReason: this.informatieRapportageFg.value.financialReportingPeriodDifferentThanAnnualReason,
            financialReportingPeriodDifferentThanAnnualImpactComparatives: this.informatieRapportageFg.value.financialReportingPeriodDifferentThanAnnualImpactComparatives,
            documentRelatesToIndividualEntityOrGroup: this.informatieRapportageFg.value.documentRelatesToIndividualEntityOrGroup,
            basisOfPreparation: this.informatieRapportageFg.getRawValue().basisOfPreparation,
            documentPresentationCurrency: this.informatieRapportageFg.value.documentPresentationCurrency,
            incomeStatementClassificationType: this.informatieRapportageFg.value.incomeStatementClassificationType,
            cashFlowStatementMethodType: this.informatieRapportageFg.value.cashFlowStatementMethodType,
            financialStatementsDateOfPreparation: this.informatieRapportageFg.value.financialStatementsDateOfPreparation,
            documentAdoptionStatus: this.informatieRapportageFg.value.documentAdoptionStatus,
            documentAdoptionDate: this.informatieRapportageFg.value.documentAdoptionDate,
            documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuracies: this.informatieRapportageFg.value.documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuracies,
            documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuraciesExplanation: this.informatieRapportageFg.value.documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuraciesExplanation,
            documentResubmissionDueToUnsurmountableInaccuracies: this.informatieRapportageFg.value.documentResubmissionDueToUnsurmountableInaccuracies,
            documentResubmissionDueToUnsurmountableInaccuraciesExplanation: this.informatieRapportageFg.value.documentResubmissionDueToUnsurmountableInaccuraciesExplanation,
            emailAddressFull: this.informatieRapportageFg.value.emailAddressFull,
            publicationWNTInTheConsolidatedStatutoryAccounts: this.informatieRapportageFg.value.publicationWNTInTheConsolidatedStatutoryAccounts,
            referenceToTheSeniorOfficialsAndCorrespondingStatutoryEntities: this.informatieRapportageFg.value.referenceToTheSeniorOfficialsAndCorrespondingStatutoryEntities,
            applicableMaximumRemunerationInstitution: this.informatieRapportageFg.value.applicableMaximumRemunerationInstitution,
          },
          jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
        }
      } as Jaarrapportage
      this.jrDataService.updateEntity(this.jrEntity);
    },0)
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.jrDataService.updateEntity(this.jrEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.informatieRapportageFg.dirty;
  }
}
